var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLockIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 8V10.1C18.81 10.04 18.31 10.01 17.75 10V8C17.75 4.85 16.86 2.75 12.5 2.75C8.14 2.75 7.25 4.85 7.25 8V10C6.69 10.01 6.19 10.04 5.75 10.1V8C5.75 5.1 6.45 1.25 12.5 1.25C18.55 1.25 19.25 5.1 19.25 8Z",
    fill: "#F7AC1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.5 15V17C22.5 21 21.5 22 17.5 22H7.5C3.5 22 2.5 21 2.5 17V15C2.5 11.66 3.2 10.41 5.75 10.1C6.19 10.04 6.69 10.01 7.25 10H17.75C18.31 10.01 18.81 10.04 19.25 10.1C21.8 10.41 22.5 11.66 22.5 15Z",
    fill: "#F7AC1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17.0008C8.37 17.0008 8.24 16.9708 8.12 16.9208C7.99 16.8708 7.89001 16.8008 7.79001 16.7108C7.61001 16.5208 7.5 16.2608 7.5 16.0008C7.5 15.8708 7.52999 15.7408 7.57999 15.6208C7.62999 15.5008 7.70001 15.3908 7.79001 15.2908C7.89001 15.2008 7.99 15.1308 8.12 15.0808C8.49 14.9208 8.92999 15.0108 9.20999 15.2908C9.29999 15.3908 9.37001 15.5008 9.42001 15.6208C9.47001 15.7408 9.5 15.8708 9.5 16.0008C9.5 16.2608 9.38999 16.5208 9.20999 16.7108C9.01999 16.8908 8.76 17.0008 8.5 17.0008Z",
    fill: "#F7AC1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.9992C12.23 16.9992 11.98 16.8892 11.79 16.7092C11.7 16.6092 11.63 16.4992 11.58 16.3792C11.53 16.2592 11.5 16.1292 11.5 15.9992C11.5 15.7292 11.61 15.4792 11.79 15.2892C12.16 14.9192 12.83 14.9192 13.21 15.2892C13.39 15.4792 13.5 15.7292 13.5 15.9992C13.5 16.1292 13.47 16.2592 13.42 16.3792C13.37 16.4992 13.3 16.6092 13.21 16.7092C13.02 16.8892 12.76 16.9992 12.5 16.9992Z",
    fill: "#F7AC1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.9992C16.24 16.9992 15.98 16.8892 15.79 16.7092C15.61 16.5192 15.5 16.2692 15.5 15.9992C15.5 15.7292 15.61 15.4792 15.79 15.2892C16.17 14.9192 16.84 14.9192 17.21 15.2892C17.25 15.3392 17.29 15.3892 17.33 15.4492C17.37 15.4992 17.4 15.5592 17.42 15.6192C17.45 15.6792 17.47 15.7392 17.48 15.7992C17.49 15.8692 17.5 15.9392 17.5 15.9992C17.5 16.2592 17.39 16.5192 17.21 16.7092C17.02 16.8892 16.76 16.9992 16.5 16.9992Z",
    fill: "#F7AC1B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lock-icon.17869cad629ce63d26ea4b1876f6cda4.svg";